import React from 'react'
import PlanificationTable from './planification/PlanificationTable'
import HeaderPlanification from './planification/HeaderPlanification'

const PlanificationOnglet = ({ moveTasksDay }) => {
	return <>
		<HeaderPlanification />
		<PlanificationTable moveTasksDay={moveTasksDay} />
	</>
}

export default PlanificationOnglet